import React from "react"
import {Col, Form, Row, Switch} from "antd";
import IViewTableSettings from "../../../../model/interface/dataStorage/view/table/IViewTableSettings";
import {IViewSettingsProps} from "../ViewSettings";
import LocaleText from "../../settings/dictionary/LocaleText";
import ViewTableSettings from "../table/ViewTableSettings";

interface IProps extends IViewSettingsProps {
}

class ViewPivotTableStateSettings extends React.Component<IProps, IViewTableSettings> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            tablePageSize: 20,
            tableHeaderSticky: true,
            ...props.settings
        }
    }

    onChangeForm = (values: any): void => {
        this.setState(state => ({...state, ...values}), () => this.props.onChange({...values}))
    }

    render() {
        return (
            <>
                <Form onValuesChange={this.onChangeForm} initialValues={this.state}>
                    <Row gutter={12}>
                        <Col sm={12}>
                            <Form.Item name={'pivotTableHideSideBar'} label={<LocaleText code={'configuration.view.pivot-table.hide-side-bar'} fallback={'Znepřístupnit boční panel'}/>}
                                       valuePropName={"checked"}>
                                <Switch/>
                            </Form.Item>
                        </Col>
                        <Col sm={12}>
                            <Form.Item name={'pivotTableDefaultHideSideBar'} label={<LocaleText code={'configuration.view.pivot-table.default-hide-side-bar'} fallback={'Na začátku skrýt boční panel'}/>}
                                       valuePropName={"checked"}>
                                <Switch/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <ViewTableSettings {...this.props}/>
            </>
        )
    }
}


export default ViewPivotTableStateSettings